import { setupResourceStore } from '@/utils'
import Manifest from '@/resources/Manifest';

const resource = setupResourceStore(Manifest)


const state = {
  ...resource.state
};

const getters = {
  ...resource.getters
};

const actions = {
  ...resource.actions
};

const mutations = {
  ...resource.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};